import React from 'react';
import moment from 'moment';
import { AudienceExportStatus } from '../../audienceManager';
import { NA } from '../../../content';
import { Routes } from '../../../constants';
import { REMODELING_COLUMN_KEYS } from '../constants';
import { RemodelingRecord } from '../types';
import { isNil, noop } from 'lodash';
import * as Styled from '../index.styles';

/**
 * Render remodeling table row cells
 * @param record - The remodeling record data object
 * @returns React fragment containing table cells for the row
 */
export const renderRemodelingRowCells = (
  record: RemodelingRecord
): React.ReactElement => {
  return (
    <>
      <td key={REMODELING_COLUMN_KEYS.EXPORT_DATE}>
        <Styled.DateCell>
          {!isNil(record.exportDate)
            ? moment(record.exportDate).format('MM/DD/YYYY hh:mm A')
            : NA}
        </Styled.DateCell>
      </td>
      <td key={REMODELING_COLUMN_KEYS.STATUS}>
        <AudienceExportStatus
          latestExportHistory={record.exportHistory}
          setCurrentAudience={noop}
          isInHouseExport={false}
          audience={null}
          currentAudience={null}
          uiAudienceManagerExportErrorStatusDetailsVisible
        />
      </td>
      <td key={REMODELING_COLUMN_KEYS.CPM}>
        <Styled.CurrencyCell>
          {!isNil(record.cpm) ? `$${record.cpm.toFixed(1)}` : NA}
        </Styled.CurrencyCell>
      </td>
      <td key={REMODELING_COLUMN_KEYS.POM}>
        <Styled.NumberCell>
          {!isNil(record.pom) ? record.pom.toLocaleString('en-US') : NA}
        </Styled.NumberCell>
      </td>
      <td key={REMODELING_COLUMN_KEYS.CUT_SIZE}>
        <Styled.NumberCell>
          {!isNil(record.cutSize) ? `${record.cutSize}%` : NA}
        </Styled.NumberCell>
      </td>
      <td key={REMODELING_COLUMN_KEYS.SEED_SIZE}>
        <Styled.NumberCell>
          {!isNil(record.seedSize)
            ? record.seedSize.toLocaleString('en-US')
            : NA}
        </Styled.NumberCell>
      </td>
      <td key={REMODELING_COLUMN_KEYS.DELIVERED_SIZE}>
        <Styled.NumberCell>
          {!isNil(record.deliveredSize)
            ? record.deliveredSize.toLocaleString('en-US')
            : NA}
        </Styled.NumberCell>
      </td>
      <td key={REMODELING_COLUMN_KEYS.AUDIENCE_ID} style={{ textAlign: 'right' }}>
        <Styled.DateCell>
          {record.audienceId ? (
            <Styled.EditAudienceLink
              href={`${Routes.AUDIENCE_STUDIO_EDITOR}/${record.audienceId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {record.audienceId}
            </Styled.EditAudienceLink>
          ) : (
            NA
          )}
        </Styled.DateCell>
      </td>
    </>
  );
};
